import { FaPencilAlt, FaTrashAlt } from "react-icons/fa";

const PurchaseItemTable = ({
    tableItems,
    editingIndex,
    handleEditItem,
    handleRemoveItem,
    formatSalesValue
}) => {
    if (tableItems.length === 0) {
        return (
            <div className="text-sm bg-white rounded-lg shadow-md p-12 text-center h-full flex items-center justify-center">
                <p className="text-gray-400">No items added yet.</p>
            </div>
        );
    }

    const totalQuantity = tableItems.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);

    const totalVat = tableItems.reduce((sum, item) => sum + (Number(item.vat) || 0), 0);

    const grandTotal = tableItems.reduce((sum, item) => sum + (Number(item.total) || 0), 0);

    return (
        <div className="bg-white rounded-sm shadow-md overflow-hidden">
            <div className="overflow-auto max-h-[420px] tiny-scrollbar">
                <table className="w-full text-center text-sm h-full">
                    <thead className="bg-gray-100 sticky top-0 z-20">
                        <tr>
                            <th className="px-2 py-2.5 font-semibold text-gray-700">Item</th>
                            <th className="px-2 py-2.5 font-semibold text-gray-700">UOM</th>
                            <th className="px-2 py-2.5 font-semibold text-gray-700">Dept</th>
                            <th className="px-2 py-2.5 font-semibold text-gray-700">Stock Type</th>
                            <th className="px-2 py-2.5 font-semibold text-gray-700">Qty</th>
                            <th className="px-2 py-2.5 font-semibold text-gray-700">Rate</th>
                            <th className="px-2 py-2.5 font-semibold text-gray-700">VAT</th>
                            <th className="px-2 py-2.5 font-semibold text-gray-700">Total</th>
                            <th className="px-2 py-2.5 font-semibold text-gray-700">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 align-top">
                        {tableItems.map((item, i) => (
                            <tr
                                key={i}
                                className={`hover:bg-gray-50 ${editingIndex === i ? "bg-blue-50 ring-1 ring-inset ring-blue-300" : ""}`}
                            >
                                <td className="p-2 text-gray-900">
                                    <div className="flex justify-center items-center gap-1.5 whitespace-nowrap">
                                        {item.ItemName}
                                        {item.isNew && (
                                            <span className="px-1.5 py-0.5 text-xs bg-yellow-100 text-yellow-700 rounded font-medium">New</span>
                                        )}
                                    </div>
                                </td>
                                <td className="p-2 text-gray-600">{item.primary_unit || '-'}</td>
                                <td className="p-2 text-gray-600">{item.Department || '-'}</td>
                                <td
                                    className={`p-2 font-medium ${item.stocktype === "Stockable"
                                        ? "text-green-700 bg-green-50"
                                        : item.stocktype === "Non-Stockable"
                                            ? "text-blue-700 bg-blue-50"
                                            : "text-gray-600"
                                        }`}
                                >
                                    {item.stocktype}
                                </td>
                                <td className="p-2 text-gray-900">{item.quantity}</td>
                                <td className="p-2 text-gray-900">{formatSalesValue(item.Rate)}</td>
                                <td className="p-2 text-gray-900">{formatSalesValue(item.vat)}</td>
                                <td className="p-2 font-semibold text-gray-900">{formatSalesValue(item.total)}</td>
                                <td className="p-2">
                                    <div className="flex justify-center items-center gap-1.5">
                                        <button
                                            onClick={() => handleEditItem(i)}
                                            title="Edit"
                                            className={`h-7 w-7 flex items-center justify-center rounded border transition-colors ${editingIndex === i ? "bg-blue-600 border-blue-600 text-white" : "border-gray-300 text-blue-600 hover:bg-blue-50"}`}
                                        >
                                            <FaPencilAlt className="h-3 w-3" />
                                        </button>
                                        <button
                                            onClick={() => handleRemoveItem(i)}
                                            title="Remove"
                                            className="h-7 w-7 flex items-center justify-center rounded border border-gray-300 text-red-600 hover:bg-red-50 transition-colors"
                                        >
                                            <FaTrashAlt className="h-3 w-3" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot className="bg-gray-100 sticky bottom-0 z-10">
                        <tr className="font-semibold text-gray-800">
                            <td colSpan={4} className="px-2 py-2 text-right">Totals:</td>

                            <td className="px-2 py-2 text-center">
                                {totalQuantity}
                            </td>

                            <td className="px-2 py-2"></td>

                            <td className="px-2 py-2 text-center">
                                {formatSalesValue(totalVat)}
                            </td>

                            <td className="px-2 py-2 text-center">
                                {formatSalesValue(grandTotal)}
                            </td>

                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
};

export default PurchaseItemTable;